import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '../../../../shared/utils';
import { PATHS, PATHFINDER } from '../../constants';


export const getCategoryPath = ({ id }, source, locale) => {
    if (!id) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(id, 10))) {
        return PATHS.ROOT;
    }

    const categorySlug = translate(`categories.category_${id}.cached_slug`, locale);
    const params = { id: categorySlug };
    const options = { query: { source } };

    return categorySlug ? pathfinder(PATHFINDER.CATEGORY, params, options) : '';
};
